/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const CheckboxSelectedIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM17.7088 6.7795L9.96564 14.5227L6.21983 10.7769L5.15917 11.8375L9.43531 16.1137L9.96564 16.644L10.496 16.1137L18.7695 7.84016L17.7088 6.7795Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
